import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { mutation, buildVariables } from './update-playbook-disabled-mutation-builder';

export default function useUpdatePlaybookDisabled(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.updateIntegration },
    successMsg: 'Revision updated.',
    ...options,
  });

  const updatePlaybookDisabled = ({ playbookId, disabled, disabledNote }) => {
    return executeMutation({ variables: buildVariables({ playbookId, disabled, disabledNote }) });
  };

  return [updatePlaybookDisabled, response];
}
